import { Loader2 } from 'lucide-react'

import { cn } from '@/utils/cn'

interface SpinnerProps {
  className?: string
  label?: string
}

export function Spinner({ className, label = 'Carregando' }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      className={cn('size-5 animate-spin text-brand', className)}
    />
  )
}
